import type { BadgeProps } from './Badge'

type BadgeSize = NonNullable<BadgeProps['size']>

type AvatarStackSize =
  | 'xxsmall'
  | 'xsmall'
  | 'small'
  | 'mid'
  | 'medium'
  | 'large'
  | 'xlarge'

export function mapAvatarStackSizeToBadgeSize(
  size: AvatarStackSize,
): BadgeSize {
  switch (size) {
    case 'xxsmall':
    case 'xsmall':
      return 'small'
    case 'mid':
      return 'medium'
    case 'xlarge':
      return 'large'
    default:
      return size
  }
}
